import React from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { setFilterPayment } from "../../../features/search/slice";
import { isBoolean } from "lodash";

export const DropdownField = ({
  label = "label",
  options = [],
  componentId = "dropdown",
  onChange = () => {},
}) => {
  return (
    <Form.Select
      onChange={(e) => onChange(e)}
      aria-label="Default select example"
    >
      <option>-- Select {label} --</option>
      {options.map((option, key) => {
        return (
          <option
            key={componentId + "-options" + key}
            value={option?.value ?? key}
          >
            {option?.label ?? key}
          </option>
        );
      })}
    </Form.Select>
  );
};

const mapStateToProps = (state) => ({
  label: "payment status",
  options: [
    { value: "true", label: "received" },
    { value: "false", label: "Not received" },
  ],
  componentId: "ScholarshipDueDropdown",
});

const mapDispatchToProps = (dispatch) => ({
  onChange: (e) => {
    const value = e.target.value;
    switch (value) {
      case "true":
        dispatch(setFilterPayment(true));
        break;
      case "false":
        dispatch(setFilterPayment(false));
        break;
      default:
        dispatch(setFilterPayment(undefined));
    }
  },
});

export const PaymentFilterDropdown = connect(
  mapStateToProps,
  mapDispatchToProps
)(DropdownField);
